import fetchWithCsrf from "@core/scripts/helper/fetch-with-csrf";
import Url from "@core/scripts/helper/url";
import Logger from "@core/scripts/components/logger";

export default function fetchCartSummary(onSuccess) {
    fetchWithCsrf(Url.toAbsolute("/list/cart/summary/"),
        {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        })
        .then(async response => {
            if (response.ok) {
                const cartSummary = await response.json();
                onSuccess?.(cartSummary);
            } else {
                throw Error("fetch error");
            }
        })
        .catch((error) => {
            Logger.error("Requesting Cart Summary failed", error);
        });
}
